import type { FilterInteractionEvent } from './FilterInteractionEvent';
import { filterInteractionSchema } from './FilterInteractionSchema';

type Props = {
  filterName: string;
  filterValue: string[];
};

export const vehicleToFilterInteraction = ({
  filterName,
  filterValue,
}: Props): FilterInteractionEvent => {
  const event: FilterInteractionEvent = {
    schema: filterInteractionSchema.ref,
    data: {
      filter_name: filterName,
      filter_value: filterValue,
    },
  };

  return event;
};
